export default __webpack_public_path__ + "static/media/alert-circle-orange.ccffc46a.svg";